import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useJoinGroupMutation } from "../../slices/fun_stuff/quizUsersSlice";
import { useLoadQuizChallenges } from '../../hooks/useLoadQuizChallenges';
import { useLoadQuizGroups } from '../../hooks/useLoadQuizGroups';
import { useSocket } from "../../context/SocketContext";
import { toast } from "react-toastify";
import Loader from "../Loader";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

const JoinGroup = (({ groupKey, setGroupKey, showCreateGroupForm, showJoinGroupForm, setShowJoinGroupForm }) => {
    const socket = useSocket();

    const [inviteKey, setInviteKey] = useState('');
    const [joinGroup, { isLoading }] = useJoinGroupMutation();
    
    const { loadGroups } = useLoadQuizGroups();
    const { loadChallenges } = useLoadQuizChallenges();

    async function submitJoinGroup(e) {
        e.preventDefault();
        if (!groupKey || !inviteKey) {
            window.alert('Please make sure to enter both group_key and invite_key');
            return;
        }
        const data = {
            groupKey,
            inviteKey,
        }
        try {
            const groupData = await joinGroup(data).unwrap();
            
            setShowJoinGroupForm(false);
            await loadGroups();
            await loadChallenges();
            socket?.emit('join_group_room', { groupId: groupData.groupId, groupKey, user: groupData.payload.username }, (res) => {
                if (res.success) {
                    socket.emit('group_event', groupData);
                } else {
                    console.error('Failed to join room', res.message);
                }
            });
            toast.success('Group joined');
        } catch (error) {
            window.alert(`Error joining group: ${error?.data?.message || error.error}`);
        }
    }

    if (isLoading) return <Loader />;
    return (
    <>
    {!showCreateGroupForm && <Button className='quiz-btn-dark p-3' onClick={() => setShowJoinGroupForm(!showJoinGroupForm)}>
        {!showJoinGroupForm ? (
            <>
            <FontAwesomeIcon icon={faRightFromBracket} className="me-1" /> Join Group 
            </>
        ) : (
            <>
            Close <FontAwesomeIcon icon={faChevronUp} className="ms-1" />
            </>
        )}
    </Button>}
    {showJoinGroupForm && 
    <Form onSubmit={(e) => submitJoinGroup(e)}>
        <h4>You should have received a group_key and invite_key</h4>
        <Form.Group controlId='group-key' className="my-2">
            <Form.Label>Group Key</Form.Label>
            <Form.Control
                type="text"
                placeholder='group_key'
                onChange={e => setGroupKey(e.target.value)}
            />
        </Form.Group>
        <Form.Group controlId='invite-key' className="my-2">
            <Form.Label>Invite Key</Form.Label>
            <Form.Control
                type='text'
                placeholder="invite_key"
                onChange={(e) => setInviteKey(e.target.value)}
            />
        </Form.Group>
        <div className="d-flex justify-content-center">
            <Button variant="dark" type="submit">Join Group</Button>
        </div>
    </Form>}
    </>
    );
})

export default JoinGroup